import { Link } from "react-router-dom";
import { Info } from "lucide-react";

/**
 * Subtle commercial notice shown on revenue-adjacent pages (CRM, Outreach,
 * Brands, Media Kit). Intentionally low-contrast so it stays out of the
 * workflow but remains discoverable and clickable.
 */
export default function CommercialNotice() {
  return (
    <div
      className="mt-12 pt-6 border-t border-line flex items-start gap-2 text-xs text-ink-dim leading-relaxed"
      data-testid="commercial-notice"
    >
      <Info className="w-3.5 h-3.5 mt-0.5 flex-shrink-0 opacity-60" />
      <p>
        Commercial opportunities facilitated through PITCHD may be subject to platform fees or commissions in
        accordance with our{" "}
        <Link
          to="/commercial-terms"
          className="text-ink-muted hover:text-volt underline underline-offset-2"
          data-testid="commercial-notice-link"
        >
          Commercial Terms
        </Link>
        .
      </p>
    </div>
  );
}
